export const ON_CLICK_EVENTS = {
  ON_TRANSACTION_CATEGORY_CLICK: 'onTransactionCategoryClick',
  ON_TRANSACTION_CATEGORY_CHANGED: 'onTransactionCategoryChanged',
  ON_TRANSACTION_MANUAL_ADD_CLICK: 'onTransactionManualAddClick',
  ON_TRANSACTION_MANUAL_ADD_ADDED: 'onTransactionManualAddAdded',
  ON_TRANSACTION_DATE_CHANGED: 'onTransactionDateChanged',
  ON_TRANSACTION_DATE_CLICK: 'onTransactionDateClick',
  ON_TRANSACTION_DELETE_CANCEL: 'onTransactionDeleteCancel',
  ON_TRANSACTION_DELETE_CLICK: 'onTransactionDeleteClick',
  ON_TRANSACTION_DELETE_DELETED: 'onTransactionDeleted',
  ON_TRANSACTION_DELETE_LOGO_CANCEL: 'onTransactionDeleteLogoCancel',
  ON_TRANSACTION_DELETE_LOGO_CLICK: 'onTransactionDeleteLogoClick',
  ON_TRANSACTION_DELETE_LOGO_DELETED: 'onTransactionDeletedLogo',
  ON_TRANSACTION_DESCRIPTION_EDIT_CLICK: 'onTransactionDescriptionEditClick',
  ON_TRANSACTION_DESCRIPTION_SAVE_CLICK: 'onTransactionDescriptionSaveClick',
  ON_TRANSACTION_EXPORT_CSV_CLICK: 'onTransactionExportCsvClick',
  ON_TRANSACTION_HIDDEN: 'onTransactionHidden',
  ON_TRANSACTION_HIDE_CLICK: 'onTransactionHideClick',
  ON_TRANSACTION_HIDE_CANCEL_CLICK: 'onTransactionHideCancelClick',
  ON_TRANSACTION_LIST_ITEM_CLICK: 'onTransactionListItemClick',
  ON_TRANSACTION_MEMO_CHANGED: 'onTransactionMemoChanged',
  ON_TRANSACTION_MEMO_CLICK: 'onTransactionMemoClick',
  ON_TRANSACTION_SPLIT_ADD_CLICK: 'onTransactionSplitAddClick',
  ON_TRANSACTION_SPLIT_CANCEL_CLICK: 'onTransactionSplitCancelClick',
  ON_TRANSACTION_SPLIT_CATEGORY_CLICK: 'onTransactionSplitCategoryClick',
  ON_TRANSACTION_SPLIT_CLICK: 'onTransactionSplitClick',
  ON_TRANSACTION_SPLIT_DELETE_CLICK: 'onTransactionSplitDeleteClick',
  ON_TRANSACTION_SPLIT_SAVE_CLICK: 'onTransactionSplitSaveClick',
  ON_TRANSACTION_TAGS_CHANGED: 'onTransactionTagsChanged',
  ON_TRANSACTION_TAGS_CLICK: 'onTransactionTagsClick',
  ON_TRANSACTION_TAGS_TAG_ADD_CANCEL_CLICK: 'onTransactionTagsTagAddCancelClick',
  ON_TRANSACTION_TAGS_TAG_ADD_CLICK: 'onTransactionTagsTagAddClick',
  ON_TRANSACTION_TAGS_TAG_ADDED: 'onTransactionTagsTagAdded',
  ON_TRANSACTION_TAGS_TAG_DELETE_CLICK: 'onTransactionTagsTagDeleteClick',
  ON_TRANSACTION_TAGS_TAG_DELETE_CANCEL_CLICK: 'onTransactionTagsTagDeleteCancelClick',
  ON_TRANSACTION_TAGS_TAG_DELETED: 'onTransactionTagsTagDeleted',
  ON_TRANSACTION_TAGS_TAG_EDIT_CLICK: 'onTransactionTagsTagEditClick',
  ON_TRANSACTION_TAGS_TAG_EDIT_SAVED: 'onTransactionTagsTagEditSavedClick',
  ON_TRANSACTION_TOGGLE_FLAG_CLICK: 'onTransactionToggleFlagClick',
  ON_TRANSACTION_UNHIDDEN: 'onTransactionUnHidden',
  ON_TRANSACTION_UNHIDE_CLICK: 'onTransactionUnHideClick',
  ON_TRANSACTION_UNHIDE_CANCEL_CLICK: 'onTransactionUnHideCancelClick',
  ON_TRANSACTION_UNSPLIT: 'onTransactionUnsplit',
  ON_TRANSACTION_UNSPLIT_CANCEL: 'onTransactionUnsplitCancel',
}
